import * as Scrivito from "scrivito";

Scrivito.provideWidgetClass("TabWidget", {
  attributes: {
    tabs: ["widgetlist", { only: "TabItemWidget" }],
    style: ["enum", { values: ["default-style", "simple-style"] }],
    asHeadline: ["enum", { values: ["h2", "h3", "h4", "h5", "h6"] }],
  },
});
